import { MmaoService } from '@app/shared/components/mmao/services/mmao.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';

@Component({
  selector: 'vc-preview-box',
  templateUrl: './preview-box.component.html',
  styleUrls: ['./preview-box.component.scss']
})
export class PreviewBoxComponent implements OnInit {
  @Input() title: string;
  @Input() right_pos = 0;
  @Input() width = 0;
  @Input() isActive = 0;
  @Output() resetBox = new EventEmitter<boolean>();

  public isLgUp = false;

  constructor(private store$: Store<IAppState>, private mmaoService: MmaoService) {}

  ngOnInit() {
    this.store$.select('device').subscribe(
      res => {
        this.isLgUp = res.isLgUp;
      },
      () => {
        /* Silently catch exception */
      }
    );

    this.mmaoService.hideNotifications.subscribe(
      _ => {
        if (!this.isLgUp) {
          this.resetBox.emit(true);
        }
      },
      _ => {}
    );
  }

  closePreviewBox() {
    this.resetBox.emit(true);
  }
}
